module.exports = __webpack_public_path__ + "static/img/workerlane.0397832.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/workerlane.jpeg
// module id = JCi/
// module chunks = 62